import { createSlice } from "@reduxjs/toolkit";
import {getElementSummary, getPatternSummary, getSummary} from "./summarySlice";
import {setOptionalAttributes} from "./product/productSelectionsSlice";
import {getModules} from "./product/productDataSlice";
import {
    updateDisabledElementFields,
    updateDisabledFields,
    updatePatternSideExceptions
} from "./exceptions/disabledFieldsSlice";
import {allSidesHaveLength, getAllPatternModules} from "./product/patternSelectionsSlice";
import summaryApi from "../configurator/services/summaryApi";
import APIService from "../configurator/services/APIService";
import {setAgencyDetails, setAgencyParams, setQuoteId} from "./details/projectDetailsSlice";
import DataCombiner from "./helpers/dataCombiner";

export const configuratorStateSlice =  createSlice({
    name: 'configuratorState',
    initialState: {
        stateLoading: 'idle',
        currentUrl: "",
        notices: [],
        errors: [],
        errorFields: [],
        lockedFieldsIgnoringDisabled: [],
        productImage: "",
        isPattern: false,
        hasElements: false,
        elementSaveShouldUpdate: false,
        readyToSave: false,
        saving: false,
        shouldUpdateModules: false,
        elementsThatShouldUpdateModules: [],
        displayOptionalAndSummary: false,
        displayPatternSummary: false,
        displayElementSummary: false,
        readyForShapeSummary : false,
        shapeRequestPending: false,
        shapeElementsMatchSelections: false,
        elementsDisplayingOptions: [],
        elementsShowingHidden: [],
        elementOptionalDisplaySection: null,
        catalogNumber: "",
        catalogNumberWithoutOptional: "",
        catalogNumberLookup: "",
        patternErrorMessages: [],
        patternEditType: "",
        importFeedback: [],
        quickship: null,
        quickshipInt: null,
        shouldRedirect: false,
        uiState: {
            displayModuleOverview: true,
            expandCategories: true,
            expandProducts: true,
            displayImportModal: false,
            displayElementOptionModal: false,
        }
    },
    reducers: {
        configuratorStateLoading(state ,action){
            if(state.stateLoading == 'idle'){
                state.stateLoading = 'pending'
            }
        },
        configuratorStateLoadingToggledIdle(state, action){
          if(state.stateLoading == 'pending'){
              state.stateLoading = 'idle'
          }
        },
        displayOptionalAndSummaryUpdated(state, action) {
            // if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.displayOptionalAndSummary = action.payload
            // }
        },
        displayPatternSummaryUpdated(state, action) {
            if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.displayPatternSummary = action.payload
            }
        },
        catalogNumberSet(state, action){
            if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.catalogNumber = action.payload;
            }
        },
        setCatalogNumberLookup(state, action){
            if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.catalogNumberLookup = action.payload;
            }
        },
        catalogNumberWithoutOptionalSet(state, action){
            if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.catalogNumberWithoutOptional = action.payload;
            }
        },
        isPatternSet(state, action){
            if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.isPattern = action.payload;
            }
        },
        patternErrorMessagesSet(state, action){
            if(state.stateLoading == 'pending'){
                state.stateLoading = 'idle';
                state.patternErrorMessages = action.payload;
            }
        },
        moduleUiDisplayChanged(state, action) {
            state.uiState.displayModuleOverview = action.payload
        },
        expandCategoriesChanged(state, action){
            state.uiState.expandCategories = action.payload
        },
        expandProductsChanged(state, action){
            state.uiState.expandProducts = action.payload
        },
        shouldUpdateModulesSet(state, action){
            state.shouldUpdateModules = action.payload;
        },
        setPatternEditType(state,action){
            state.patternEditType = action.payload;
        },
        setErrors(state, action){
            state.errors = action.payload;
        },
        setErrorFields(state, action){
            state.errorFields = action.payload;
        },
        setLockedFieldsIgnoringDisabled(state, action){
            state.lockedFieldsIgnoringDisabled = action.payload
        },
        setCurrentUrl(state, action){
            state.currentUrl = action.payload
        },
        setHasElements(state, action){
            state.hasElements = action.payload
        },
        setDisplayElementSummary(state, action){
            state.displayElementSummary = action.payload;
        },
        setElementsDisplayingOptions(state,action){
            state.elementsDisplayingOptions = action.payload;
        },
        setElementsShowingHidden(state, action){
          state.elementsShowingHidden = action.payload;
        },
        setElementToModuleUpdate(state, action){
            state.elementsThatShouldUpdateModules = action.payload;
        },
        setElementSaveShouldUpdate(state, action) {
            state.elementSaveShouldUpdate = action.payload;
        },
        setReadyToSave(state, action) {
            state.readyToSave = action.payload;
        },
        setSaving(state, action) {
            state.saving = action.payload;
        },
        setDisplayImportModal(state, action) {
            state.uiState.displayImportModal = action.payload;
        },
        setImportFeedback(state, action) {
            state.importFeedback = action.payload;
        },
        setReadyForShapeSummary(state,action) {
            state.readyForShapeSummary = action.payload
        },
        setShapeRequestPending(state, action) {
            state.shapeRequestPending = action.payload
        },
        setShapeElementsMatchSelections(state, action) {
            state.shapeElementsMatchSelections = action.payload
        },
        setQuickship(state, action) {
            state.quickship = action.payload
        },
        setQuickshipInt(state, action) {
            state.quickshipInt = action.payload;
        },
        setShouldRedirect(state, action) {
            state.shouldRedirect = action.payload;
        },
        setDisplayElementOptionsModal(state, action) {
            state.uiState.displayElementOptionModal = action.payload;
        },
        setElementOptionalDisplaySection(state, action) {
          state.elementOptionalDisplaySection = action.payload;
        },
    }
});
export const { configuratorStateLoading, configuratorStateLoadingToggledIdle, displayOptionalAndSummaryUpdated, catalogNumberSet, setCatalogNumberLookup, isPatternSet, catalogNumberWithoutOptionalSet, displayPatternSummaryUpdated, patternErrorMessagesSet, shouldUpdateModulesSet, setPatternEditType, setErrors, moduleUiDisplayChanged, expandProductsChanged, expandCategoriesChanged, setErrorFields, setLockedFieldsIgnoringDisabled, setCurrentUrl, setHasElements, setDisplayElementSummary, setElementsDisplayingOptions, setElementToModuleUpdate, setElementSaveShouldUpdate, setElementsShowingHidden, setReadyToSave, setSaving, setDisplayImportModal, setImportFeedback, setReadyForShapeSummary, setShapeRequestPending, setShapeElementsMatchSelections, setQuickship, setQuickshipInt, setShouldRedirect, setDisplayElementOptionsModal, setElementOptionalDisplaySection} = configuratorStateSlice.actions;

export const manageConfiguratorState = () => (dispatch, getState) => {
    // here we call various functions to update configurator state
    dispatch(generateCatalogNumber())
    dispatch(updateDisabledFields());
    dispatch(updateDisabledElementFields());
    dispatch(updatePatternSideExceptions());
    dispatch(manageDisplaySummary())
    dispatch(managePatternSummary())
    dispatch(manageElementSummary());
    // reset quickship whenever we update configurator state
    dispatch(setQuickship(null))
    dispatch(setQuickshipInt(null))

}

export const manageDisplaySummary = () => async (dispatch, getState) => {
    dispatch(configuratorStateLoading());
    const state = getState();
    const reducerState = state.configuratorStateReducer;
    const currentState = reducerState.displayOptionalAndSummary;

    // get all attributes and filter out optional and per module

    const requiredAttributes = state.productSelectionsReducer.requiredAttributes;

    // get all current selections, filtering out optional, per module and empty selections
    const allSelections = state.productSelectionsReducer.requiredSelections;
    const requiredSelections = allSelections.filter(attr => attr.selection != "");
    const shouldDisplay = requiredAttributes.length == requiredSelections.length
    // update summary
    if(shouldDisplay && requiredAttributes.length != 0){
        if(state.productSelectionsReducer.optionalSelections.length < 1) {
            dispatch(setOptionalAttributes())
            // this will initially load modules
            if(!reducerState.isPattern){
                await dispatch(getModules())
            }

        }

        if(!reducerState.isPattern && !reducerState.hasElements) {
            if(reducerState.shouldUpdateModules) {
                //here we update modules.
                await dispatch(getModules())
            }
            dispatch(getSummary())
        } else {
            const sidesHaveLength = allSidesHaveLength(getState().patternSelectionsReducer.sides);
            if(reducerState.shouldUpdateModules && sidesHaveLength){
                dispatch(getAllPatternModules());
            }
        }
    }

    if( shouldDisplay == currentState || requiredAttributes.length == 0){
        dispatch(configuratorStateLoadingToggledIdle());
        return;
    }
    dispatch(displayOptionalAndSummaryUpdated(shouldDisplay))
}

export const generateCatalogNumber = () => (dispatch, getState) => {
    dispatch(configuratorStateLoading());

    const state = getState();
    const product = state.productDataReducer;
    const productSelections = product.attribute_selections;
    let selections = [];
    const requiredSelections = [];

    if (product.family) {
        requiredSelections.push(product.family);
    }

    if (productSelections) {
        productSelections.forEach((sel) => {
            // selections that are not optional or per module are required selection
            // we add them to this array so we can generate a requiredAttribute only
            // catalog number, which is need to get module options. Optional and Module options
            // are added separately after
            if(!sel.optional && !sel.per_module){
                requiredSelections.push(sel.selection)
            }

        })
    }

    // module and optional need to be sorted alphabetically otherwise the lookup will error
    if(productSelections){
        selections = requiredSelections;
        const optionalAndModule = productSelections.filter(ps => ps.optional || ps.per_module);
        optionalAndModule.sort((a,b) => {
            return (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0;
        });

        optionalAndModule.forEach(oam => {
            selections.push(oam.selection);
        })
    }

    const catalogNumber = selections.join('');
    const catalogWithoutOptional = requiredSelections.join('');

    dispatch(catalogNumberSet(catalogNumber))
    dispatch(setCatalogNumberWithoutOptional(catalogWithoutOptional))
}

export const managePatternSummary = () => (dispatch, getState) => {
    const state = getState();
    const isPattern = state.configuratorStateReducer.isPattern;
    const sidesDisplay = state.configuratorStateReducer.displayOptionalAndSummary;

    if(!isPattern || !sidesDisplay){
        return;
    }

    const patternSides = getState().patternSelectionsReducer.sides;
    let displayPatternSummary = true;
     // go through each side and check if all side required attributes are filled
    if(patternSides.length == 0){
        displayPatternSummary = false;
    }
    patternSides.forEach((side, index) => {
        const sideKey = Object.keys(side)[0];
        const requiredAttributeLength = side[sideKey].sideRequiredAttributes.length;
        const requiredSelectionsLength = side[sideKey].sideRequiredSelections.filter(sel => sel.selection != "").length;
        if( requiredAttributeLength == 0 || requiredAttributeLength != requiredSelectionsLength){
            displayPatternSummary = false;
        }
    })

    if(displayPatternSummary){
         dispatch(getPatternSummary())
    }
    dispatch(setDisplayPatternSummary(displayPatternSummary));
}

export const manageElementSummary = () => (dispatch,getState) => {
    const elements = getState().productElementsReducer.elements_with_selections;
    const shapedAttributes = getState().productSelectionsReducer.shapedAttributes;
    const shapeElementsMatchSelections = getState().configuratorStateReducer.shapeElementsMatchSelections;
    let isReady = true;

    if(shapedAttributes.length > 0) {
        isReady = shapeElementsMatchSelections;
    } else {
        if (Object.entries(elements).length == 0) {
            isReady = false;
        }

        for (let element in elements) {
            const elementRequiredAttributes = elements[element].product_attributes.filter(pa => !pa.optional && !pa.per_module);
            const elementRequiredSelections = elements[element].attribute_selections.filter(as => !as.optional && !as.per_module && as.selection);
            if (elementRequiredAttributes.length != elementRequiredSelections.length) {
                isReady = false;
            }
        }
    }

    if(isReady){
        dispatch(getElementSummary());
        dispatch(setReadyForShapeSummary(false));
    }
    dispatch(setDisplayElementSummary(isReady));
};

export const compareSummaryCatWithPartNumber = (catalog, summary_catalog) => (dispatch, getState) => {
    // this method is used after catalog lookup runs, it checks if the
    // catalog we recieved from summary is different from what was entered,
    // if it is we display invalid configuration
    if(catalog.trim().toUpperCase() != summary_catalog.toUpperCase()){
        dispatch({type: 'ADD_NOTICE', notice_type:'catalog_number', message:'Invalid part number, closest alternative generated'})
        dispatch(updateCatalogLookup(summary_catalog.toUpperCase()))
    }

}

export const setDisplayPatternSummary = (value) => dispatch => {
    dispatch(configuratorStateLoading());
    dispatch(displayPatternSummaryUpdated(value));
}

export const setDisplaySummary = (value) => dispatch => {
    dispatch(configuratorStateLoading());
    dispatch(displayOptionalAndSummaryUpdated(value));
}

export const setCatalogNumberWithoutOptional = (value) => dispatch =>  {
    dispatch(configuratorStateLoading())
    dispatch(catalogNumberWithoutOptionalSet(value))
}

export const updateCatalogLookup = (value) => dispatch => {
    dispatch(configuratorStateLoading())
    dispatch(setCatalogNumberLookup(value))
}

export const setCatalogNumber = (value) => dispatch => {
    dispatch(configuratorStateLoading());
    dispatch(catalogNumberSet(value));
}

export const setIsPattern = value => dispatch => {
    dispatch(configuratorStateLoading());
    dispatch(isPatternSet(value));
}

export const setPatternErrorMessages = value => dispatch => {
    dispatch(configuratorStateLoading());
    dispatch(patternErrorMessagesSet(value));
}

export const moduleUiChanged = value => (dispatch, getState) =>{
    const state = getState()
    const current = state.configuratorStateReducer.uiState.displayModuleOverview;
    const identifier = value.id;
    const val = value.value;
    const updated = Object.assign({}, current, {
        [identifier] : val,
    })
    dispatch(moduleUiDisplayChanged(updated));
}

export const addErrorFields = (value) => (dispatch , getState) => {
    const state = getState();
    const currentErrorFields = Object.assign([], state.configuratorStateReducer.errorFields);
    currentErrorFields.push(value);

    dispatch(setErrorFields(currentErrorFields));

}

export const addElementsDisplayingOptions = (id) => (dispatch, getState) =>{
    const elementsDisplayingOptions = Object.assign([], getState().configuratorStateReducer.elementsDisplayingOptions);
    if(!elementsDisplayingOptions.includes(id)){
        elementsDisplayingOptions.push(id);
    }

    dispatch(setElementsDisplayingOptions(elementsDisplayingOptions));
}

export const removeElementsDisplayingOptions = (id) => (dispatch, getState) => {
    const elementsDisplayingOptions = getState().configuratorStateReducer.elementsDisplayingOptions;
    let updated = elementsDisplayingOptions.filter(ids => ids !== id);

    dispatch(setElementsDisplayingOptions(updated));
}

export const addElementToUpdateModules = (id) => (dispatch, getState) => {
    const elementsToUpdate = Object.assign([], getState().configuratorStateReducer.elementsThatShouldUpdateModules);
    if(!elementsToUpdate.includes(id)){
        elementsToUpdate.push(id);
    }
    dispatch(setElementToModuleUpdate(elementsToUpdate));
}

export const removeElementToUpdateModules = (id) => (dispatch, getState) => {
    const elementsToUpdate = getState().configuratorStateReducer.elementsThatShouldUpdateModules.filter(el => el !== id);
    dispatch(setElementToModuleUpdate(elementsToUpdate));
}

export const toggleElementShowingHidden = (id) => (dispatch, getState) => {
    let elementsShowingHidden = Object.assign([], getState().configuratorStateReducer.elementsShowingHidden);
    if(elementsShowingHidden.includes(id)){
        elementsShowingHidden = elementsShowingHidden.filter(el => el != id);
    } else {
        elementsShowingHidden.push(id);
    }
    dispatch(setElementsShowingHidden(elementsShowingHidden));
}

export const addImportFeedback = (feedback) => (dispatch, getState) => {
    const updatedFeedback = Object.assign([], getState().configuratorStateReducer.importFeedback);
    updatedFeedback.push(feedback);
    dispatch(setImportFeedback(updatedFeedback));
}

export const getAgent = () => async(dispatch, getState) => {
    const response = await APIService.get_agent();
    if(response) {
        dispatch({type: 'AGENT_DATA_RECEIVED', value: response});
        const agencyParams = {
            currency: response.agency_params.default_currency_code,
            language: response.agency_params.default_language,
            country: response.agency_params.default_country,
            price_book: response.agency_params.default_price_book,
            price_terms: response.agency_params.default_price_terms,
            commission_percent: response.agency_params.default_commission_percentage,
            overage_commission_percent: response.agency_params.default_overage_percentage,
            freight_terms: response.agency_params.default_freight_terms
        }
        dispatch(setAgencyParams(agencyParams))
    }
}

export const saveQuote = () => async(dispatch, getState) => {
    const productData = getState().productDataReducer;
    const projectDetails = getState().projectDetailsReducer;
    const patternDetails = getState().patternDetailsReducer;
    const productElements = getState().productElementsReducer;
    const configuratorState = getState().configuratorStateReducer;
    const summary = getState().summaryReducer;
    const data = DataCombiner(productData, projectDetails, patternDetails, productElements, configuratorState, summary);

    const response = await APIService.save(data);
    if( response ) {
        dispatch({type: "SUCCESS_NOTICE", value: "Successfully Saved"});
        // save quote id
        dispatch(setQuoteId(response.quote_id));
        dispatch(setShouldRedirect(true));
        return response
    } else {
        dispatch({
            type: 'ADD_NOTICE',
            notice_type: 'catalog_number',
            message: 'Having Trouble Saving This Quote... Please try again later or Contact an Administrator'
        });
        dispatch(setReadyToSave(true))
        dispatch(setSaving(false))
        return null
    }
}


export const checkQuickship = () => async (dispatch, getState) => {
    const data = getState().productDataReducer;
    const hasElements = getState().configuratorStateReducer.hasElements;
    const isPattern = getState().configuratorStateReducer.isPattern;
    const elements = getState().productElementsReducer.elements_with_selections;
    const legCatalogNumbers = getState().summaryReducer.leg_catalog_numbers
    const quantity = getState().projectDetailsReducer.quantity;
    let response;
    if(hasElements) {
        response = await summaryApi.getElementQuickship(data, quantity, elements);
    } else if(isPattern){
        response = await summaryApi.getPatternQuickship(data, quantity, legCatalogNumbers);
    } else {
        response = await summaryApi.getQuickship(data, quantity);
    }

    let quickshipInt = 0;
    if (response.quickship  === 'available_by_request'){
        quickshipInt = 1
    } else if (response.quickship  === 'contact_customer__service') {
        quickshipInt = 2
    }
    dispatch(setQuickshipInt(quickshipInt));
    dispatch(setQuickship(response.quickship));
}

export const displayElementSectionOptions = (section) => (dispatch, getState) => {
    dispatch(setDisplayElementOptionsModal(true));
    dispatch(setElementOptionalDisplaySection(section));
}

const reducer = configuratorStateSlice.reducer;
export default reducer
